import moment from "moment";
import { amountFormat } from "../../../../services/common.service";
import { Empty, Table } from "antd";
import { useTranslation } from "react-i18next";

export default function LoanStatementGrid({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      <Table
        rowHoverable={false}
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        tableLayout="fixed"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "40", "50", "100", "500"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} records`,
        }}
        bordered
        sticky={true}
        columns={[
          {
            title: "Txn Date",
            align: "left",
            key: "txnDate",

            ellipsis: true,
            render: (option) => (
              <>
                <span>
                  {option.txnDate
                    ? moment(option.txnDate).format("DD-MM-YYYY")
                    : "-"}
                </span>
              </>
            ),
          },
          {
            title: "Value Date",
            align: "left",
            key: "valueDate",

            ellipsis: true,
            render: (option) => (
              <>
                <span>
                  {option.valueDate
                    ? moment(option.valueDate).format("DD-MM-YYYY")
                    : "-"}
                </span>
              </>
            ),
          },

          {
            title: "Reference Number",
            key: "refNo",
            align: "left",
            width: 200,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>{option?.refNo}</span>
              </>
            ),
          },

          {
            title: "Amount",
            key: "amount",
            align: "right",
            width: 150,
            render: (option) => (
              <>
                {option.debitOrCredit === "D" ? (
                  <span className="debit">
                    {amountFormat(option.amount || "0")}
                  </span>
                ) : (
                  <span className="credit">
                    {amountFormat(option?.amount || "0")}
                  </span>
                )}
              </>
            ),
          },

          {
            title: "Balance",
            key: "balance",
            align: "right",
            width: 150,
            render: (option) => (
              <>
                <span>{amountFormat(option.balance || "0")}</span>
              </>
            ),
          },
        ]}
      />
    </>
  );
}
